export const openPopup = (url: string, name: string, specs: string): Promise<void> => {
    return new Promise((resolve, reject) => {
      const popup = window.open(url, name, specs);
      if (!popup) {
        reject(new Error('Popup blocked. Please allow popups for this site.'));
        return;
      }

      const interval = setInterval(() => {
        if (popup.closed) {
          clearInterval(interval);
          resolve();
        }
      }, 500);
    });
  };